<template>
  <!-- 企业账号与安全 - 1 -->
  <div class="module-One">
    <!-- 账号信息 -->
    <div class="Account-information">
      <div class="Account-information-left">
        <div class="section-title">账号信息：</div>
      </div>
      <div class="Account-information-right">
        <div class="right-box">
          <div class="tip-text" style="margin-left: -5px; color: red">
            手机号每30天可修改1次，目前您还可以修改{{
              AccountInformation.canModifiedPhone
            }}次
          </div>
        </div>
        <div class="right-box">
          <div class="telephone-icon"></div>
          <span class="info-text">{{ AccountInformation.phone }}</span>
          <el-button type="primary" class="switch-btn firm-clickable" @click="handelClick(0)">更换</el-button>
        </div>
        <div class="right-box">
          <div class="mailbox-icon"></div>
          <span class="info-text">
            {{ AccountInformation.mail ? AccountInformation.mail : "未绑定" }}
          </span>
          <el-button
            type="primary"
            class="switch-btn firm-clickable"
            @click="AccountInformation.mail ? handelClick(1) : handelClick(7)"
          >
            {{ AccountInformation.mail ? "更换" : "绑定" }}
          </el-button>
        </div>
        <div class="right-box">
          <div class="vx-icon"></div>
          <span class="info-text">{{ AccountInformation.bindWx ? "微信用户" : "未绑定" }}</span>
          <el-button
            type="primary"
            class="switch-btn firm-clickable"
            @click="AccountInformation.bindWx ? handelClick(4) : handelClick(5)"
          >
            {{ AccountInformation.bindWx ? "解绑" : "绑定" }}
          </el-button>
        </div>
      </div>
    </div>
    <!-- 登录操作记录 -->
    <div class="title-box">
      <div class="section-title">登录操作记录：</div>
    </div>
    <!-- 表格 -->
    <div class="tabulation">
      <RecordsTable :tableData="tableData" :HintMsg="HintMsg"></RecordsTable>
    </div>
    <!-- 分页 -->
    <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingRecords"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div>
    <!-- 屏蔽企业 -->
    <!-- <div class="title-box">
      <div class="section-title">屏蔽企业：</div>
      <div class="title-box-btn firm-clickable" @click="handelClick(2)">添加</div>
    </div> -->
    <!-- 表格 -->
    <!-- <div class="tabulation">
      <ShieldTable
        :tableData="tableData1"
        :HintMsg="HintMsg1"
        @handleEdit="handleEdit"
      ></ShieldTable>
    </div> -->
    <!-- 分页 -->
    <!-- <div class="paging-box">
      <div class="paging">
        <paging
          :pagingObj="pagingObj"
          @handleCurrentChange="handleCurrentChange"
        ></paging>
      </div>
    </div> -->
    <OneWindow
      :dialogVisible="dialogVisible"
      :result="result"
      :PopUpTitle="PopUpTitle"
      :AccountInformation="AccountInformation"
      @handleClose="handleClose"
      @handleUnderstand="handleUnderstand"
      @vxUnbind="vxUnbind"
    ></OneWindow>
  </div>
</template>

<script>
import {
  getCompanyAccountBindInfo, //获取公司账号绑定的手机，邮箱
  listCompanyLoginIpLog, //获取公司登录操作记录列表
  listCompanyShield, //公司屏蔽列表
  removeCompanyShield, //移除公司屏蔽
} from "../../../../../assets/api/firm/firmCenter";
import {
  getQRCode, //二维码
  unbindUnionId, //解绑微信
} from "../../../../../assets/api/index";
import RecordsTable from "./RecordsTable.vue"; //  引入登录记录表格组件
import ShieldTable from "../../../../personage/center/center/cenAccount/components/ShieldTable.vue"; // 引入屏蔽企业表格组件
import OneWindow from "./OneWindow.vue"; // 引入更换手机号/邮箱   删除屏蔽企业添加屏蔽企业弹窗
// 引入分页组件
import paging from "../../../../../components/paging.vue";
export default {
  data() {
    return {
      dialogVisible: false, //账号管理页面的总弹窗
      result: "1", // 账号管理页面 区分弹窗   0.手机号更换 1.邮箱更换 2.添加屏蔽公司  3.删除屏蔽公司
      PopUpTitle: "", //弹窗标题
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
        shield: "1", // 屏蔽企业列表的分页，用于点击分页时区分
      }, // 屏蔽企业列表分页
      pagingRecords: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 操作记录列表分页
      tableData: [], // 操作记录数据
      tableData1: [], //屏蔽公司数据
      HintMsg: "", //无数据/无权限提示语
      HintMsg1: "", //无数据/无权限提示语
      deleteId: "", // 删除项的id
      data: {
        data: {},
      },
      AccountInformation: {
        phone: "",
        mail: "",
      }, // 账号信息
    };
  },
  watch: {},
  components: {
    OneWindow,
    paging,
    RecordsTable,
    // ShieldTable,
  },
  created() {
    // 未登录预览不打接口
    const user = this.$store.getters.getUser;
    if (!(user && user.id)) return;
    // 获取获取公司账号绑定的手机，邮箱
    this.getCompanyAccountBindInfo();
    //获取公司登录操作记录列表
    this.listCompanyLoginIpLog();
    //公司屏蔽列表
    // this.listCompanyShield();
  },
  methods: {
    //刷新账号信息关闭弹窗
    vxUnbind() {
      this.getCompanyAccountBindInfo();
      this.dialogVisible = false;
    },
    //公司屏蔽列表
    listCompanyShield() {
      listCompanyShield(
        "",
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      ).then((res) => {
        if (res.code == 0) {
          this.tableData1 = res.data.list;
          this.pagingObj.totalDevice = res.data.total;
        } else if (res.code == -513) {
          this.HintMsg1 = "没有访问权限";
        }
      });
    },
    // 获取公司登录操作记录列表
    listCompanyLoginIpLog() {
      const user = this.$store.getters.getUser;
      const company = this.$store.getters.getCompany;
      if (user && user.id && user.id === company.createBy) {
        listCompanyLoginIpLog(
          "data",
          this.pagingRecords.currentPage,
          this.pagingRecords.pageSize
        ).then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.pagingRecords.totalDevice = res.data.total;
          } else if (res.code == -513) {
            this.HintMsg = "没有访问权限";
          }
        });
      }
    },
    //  获取公司账号绑定的手机，邮箱
    getCompanyAccountBindInfo() {
      this.data.data.companyId = this.$store.getters.getCompany.id;
      getCompanyAccountBindInfo(this.data).then((res) => {
        if (res.code == 0) {
          this.AccountInformation = res.data;
        }
      });
    },
    // 账号管理页更换手机号/更换邮箱  1更换手机号  2更换邮箱   3添加屏蔽公司
    handelClick(num) {
      if (!this.$checkAction()) return;
      console.log(num, this.AccountInformation.canModifiedPhone);
      if (num == 0) {
        if (this.AccountInformation.canModifiedPhone == 0) {
          this.$tool.PromptBox("warning", "本月已无可修改次数");
        } else {
          this.result = "0";
          this.PopUpTitle = "手机号更换";
          this.dialogVisible = true;
        }
      } else if (num == 1) {
        this.result = "1";
        this.PopUpTitle = "电子邮箱更换";
        this.dialogVisible = true;
      } else if (num == 2) {
        this.result = "2";
        this.PopUpTitle = "添加屏蔽企业";
        this.dialogVisible = true;
      } else if (num == 4) {
        this.$confirmWithScroll("是否进行解绑?", "解绑微信", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            unbindUnionId().then((res) => {
              if (res.code == 0) {
                this.$tool.PromptBox("success", "操作成功");
                this.getCompanyAccountBindInfo();
              }
            });
          })
          .catch(() => {});
      } else if (num == 5) {
        this.result = "5";
        this.PopUpTitle = "扫码绑定微信";
        this.dialogVisible = true;
      } else if (num == 7) {
        this.result = "7";
        this.PopUpTitle = "绑定邮箱";
        this.dialogVisible = true;
      }
    },
    // 屏蔽公司表格中的 删除
    handleEdit(index, row) {
      this.deleteId = row.id;
      this.$confirmWithScroll("确认删除对该公司的屏蔽?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeCompanyShield({ data: this.deleteId }).then((res) => {
            if (res.code == 0) {
              this.$tool.PromptBox("success", "操作成功");
              this.listCompanyShield();
            }
          });
        })
        .catch(() => {});
    },
    // 账号管理页的弹窗关闭
    handleClose(val) {
      this.dialogVisible = !this.dialogVisible;
    },
    // 账号管理页的弹窗确认
    handleUnderstand(val) {
      if (val == 2) {
        // 添加屏蔽企业 刷新屏蔽企业数据接口
        this.listCompanyShield();
      } else if (val == 3) {
        // 删除屏蔽企业
        removeCompanyShield({ data: this.deleteId }).then((res) => {
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.listCompanyShield();
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      } else {
        // 更换手机号邮箱
        this.getCompanyAccountBindInfo();
      }
      this.dialogVisible = !this.dialogVisible;
    },

    // 分页
    handleCurrentChange(val, pagingObj) {
      // 屏蔽企业表格分页
      if (pagingObj.shield) {
        this.pagingObj.currentPage = val;
        this.listCompanyShield();
      } else {
        // 登录操作记录表格分页
        this.pagingRecords.currentPage = val;
        this.listCompanyLoginIpLog();
      }
    },
  },
};
</script>

<style scoped lang="less">
// 模块1 最外层
.module-One {
  width: 100%;
  min-height: 50px;
  // 账号信息
  .Account-information {
    width: 520px;
    // height: 110px;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    margin-right: auto;
    display: flex;
    padding-bottom: 20px;
    .Account-information-left {
      min-width: 100px;
      height: 100%;
      margin-left: 20px;
      margin-right: 20px;
      .section-title {
        height: 20px;
        line-height: 20px;
        margin-top: 23px;
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
      }
    }
    .Account-information-right {
      flex: 1;
      height: 100%;
      .right-box {
        width: 100%;
        height: 20px;
        line-height: 20px;
        margin-top: 25px;
        display: flex;
        .telephone-icon {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../assets/imgs/dianhua-weijiaohuan@3x.svg");
          background-size: 100% 100%;
        }
        .mailbox-icon {
          margin: auto 0;
          width: 20px;
          height: 15px;
          background-image: url("../../../../../assets/imgs/youxiang@3x.svg");
          background-size: 100% 100%;
        }
        .vx-icon {
          width: 20px;
          height: 20px;
          background-image: url("../../../../../assets/imgs/weixin-weijiaohuan@3x.svg");
          background-size: 100% 100%;
        }
        .info-text,
        .tip-text {
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #333333;
          font-weight: 400;
          margin-left: 10px;
        }
        .switch-btn.el-button--primary {
          width: 45px !important;
          min-width: 45px !important;
          height: 20px !important;
          padding: 0 !important;
          line-height: 20px !important;
          background: #409eff !important;
          border-color: #409eff !important;
          border-radius: 5px;
          font-family: PingFangSC-Medium;
          font-size: 12px;
          color: #ffffff !important;
          font-weight: 400;
          text-align: center;
          margin-left: 40px;
        }
      }
    }
  }
  // 登录操作记录
  .title-box {
    width: 100%;
    height: 35px;
    line-height: 35px;
    margin-top: 30px;
    margin-bottom: 20px;
    display: flex;
    position: relative;
    p {
      font-family: PingFangSC-Medium;
      font-size: 20px;
      color: #333333;
      font-weight: 400;
      min-width: 200px;
    }
    .title-box-btn {
      position: absolute;
      right: 10px;
      width: 75px !important;
      height: 35px;
      background: #409eff ;
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      font-weight: 400;
      text-align: center;
      cursor: pointer;
    }
  }
  // 表格
  .tabulation {
    width: 100%;
    min-height: 300px;
    box-sizing: border-box;
  }
}
// 分页
.paging-box {
  width: 100%;
  height: 22px;
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  .paging {
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
